<div class="side-bar__container">
  <div class="side-bar__header">
    <!--  -->
    <div class="side-bar__con-status card">
      <button
        type="button"
        class="side-bar__home-button"
        aria-label="Dashboard"
        title="Dashboard"
        (click)="goToDashboard()">
        <fa-icon [icon]="['fas', 'house']"></fa-icon>
      </button>
      <app-desktop-connection-status></app-desktop-connection-status>
    </div>
    <!--  -->
    <div class="side-bar__navigation" *ngIf="showSelectedPage()">
      <app-desktop-navigation [pageName]="currentPage()" (clicked)="goBack()"></app-desktop-navigation>
    </div>
    <!--  -->
    <div class="side-bar__person-info card">
      <app-desktop-person-info></app-desktop-person-info>
    </div>
    <button type="button" *ngFor="let item of notifications.items()" class="side-bar__notification card" [class.red]="item.DisplayType === 0 && item.Importance === 2" [class.yellow]="item.DisplayType === 0 && item.Importance === 1" [class.blue]="item.DisplayType === 0 && item.Importance === 0" [class.green]="item.DisplayType === 1" (click)="notifications.open(item)">
      <span class="side-bar__notification-text">{{ item.Message | notificationPreview }}</span>
      <span class="side-bar__notification-status" role="img"
            [attr.aria-label]="(item.Confirmed ? 'webPos.NotificationRead' : 'webPos.NotificationUnread') | translate"
            [title]="(item.Confirmed ? 'webPos.NotificationRead' : 'webPos.NotificationUnread') | translate">
        <fa-icon [icon]="item.Confirmed ? readEnvelope : unreadEnvelope" aria-hidden="true"></fa-icon>
      </span>
    </button>
    <nav class="side-bar__notification-pagination"
         *ngIf="notifications.pageSize() > 0 && notifications.count() > notifications.pageSize()"
         [attr.aria-label]="'webPos.NotificationsPagination' | translate">
      <button type="button" class="side-bar__page-button"
              [attr.aria-label]="'webPos.NotificationPrevious' | translate"
              [title]="'webPos.NotificationPrevious' | translate"
              [disabled]="notifications.page() <= 1"
              (click)="notifications.changePage(notifications.page() - 1)">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M14.5 6.5 9 12l5.5 5.5" /></svg>
      </button>
      <span class="side-bar__page-indicator" aria-live="polite">
        <span class="side-bar__page-current">{{ notifications.page() }}</span>
        <span class="side-bar__page-divider" aria-hidden="true">/</span>
        <span>{{ notifications.totalPages() }}</span>
      </span>
      <button type="button" class="side-bar__page-button"
              [attr.aria-label]="'webPos.NotificationNext' | translate"
              [title]="'webPos.NotificationNext' | translate"
              [disabled]="notifications.page() >= notifications.totalPages()"
              (click)="notifications.changePage(notifications.page() + 1)">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="m9.5 6.5 5.5 5.5-5.5 5.5" /></svg>
      </button>
    </nav>
  </div>
  <div class="side-bar__footer">
    <div class="side-bar__language-controls">
      @if (state.helpLink; as url) {
        <a class="side-bar__help-link" [href]="url" target="_blank" rel="noopener noreferrer">
          {{ 'webPos.HelpLinkLabel' | translate }}
        </a>
      }
      <div class="side-bar__language-select">
        <app-desktop-language-select [languages]="languages" [selectedLanguage]="selectedLanguage" (languageChange)="onLanguageChange($event)"></app-desktop-language-select>
      </div>
    </div>
    <div class="side-bar__build-info" [class.non-production]="!isProductionEnvironment" *ngIf="buildInfo() as info" [title]="info.buildDate | date:'medium'">
      <span>{{ info.buildNumber }}</span>
    </div>
  </div>
</div>
